<div>
  <input
    #mainInput
    [attr.aria-expanded]="isMenuOverlayTriggered && isMenuVisible"
    [attr.aria-controls]="isMenuVisible ? id+'-panel' : null"
    [attr.aria-activedescendant]="isMenuVisible && activeIndex !== null ? id + '-option-'+activeIndex : null"
    aria-autocomplete="list"
    autocomplete="off"
    role="combobox"
    (focusout)="onBlur()"
    (keydown)="onKeyDown($event)"
    (keyup)="onKeyUp($event)"
    (click)="onDropdownClick($event)"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    [id]="id"
    #dropdownTrigger
    [placeholder]="placeholder ?? '' | translate"
    [ngClass]="['valg-input', 'valg-input__combo-box', isDisabled ? 'disabled': '']"
    [disabled]="isDisabled"
    [readonly]="isDisabled"
  />
  <button 
    type="button"
    [attr.aria-expanded]="isMenuOverlayTriggered && isMenuVisible"
    [attr.aria-controls]="isMenuVisible ? id+'-panel' : null"
    [attr.aria-labelledby]="dropdownLabel"
    (click)="onDropdownClick($event)"
    tabindex="-1"
    class="dropdown-arrow-button"
    [ngClass]="[fieldIcon ? 'dropdown-icon-'+fieldIcon : '']" 
    >
    <mat-icon *ngIf="!isDisabled"
      [svgIcon]="fieldIcon ? fieldIcon : SvgIcon.DropdownArrow" 
      [ngClass]="[isMenuOverlayTriggered && isMenuVisible && !fieldIcon ? 'rotated': '']" 
      (click)="dropDownArrowClicked($event)">
    </mat-icon>
  </button>
</div>
<valg-input-group *ngIf="selectedOption?.isOtherOption" [secondary]="true" >
  <label valgLabel [for]="id + '-secondary'">{{secondaryLabel ?? '' | translate}}</label>
  <input
    #otherOptionInput
    [id]="id + '-secondary'"
    valgInput
    [placeholder]="secondaryPlaceholder ?? '' | translate"
    autocomplete="off"
    (keyup)="onSecondaryInputChange($event.target)"
    [value]="_secondaryValue ?? ''"
    (focusout)="onOtherInputBlur()"
    [disabled]="ngControl.disabled ?? false"
  />
</valg-input-group>

<ng-template
  #optionsContainer="cdkConnectedOverlay"
  cdkConnectedOverlayPanelClass="valg-input-dropdown-overlay"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayPositions]="overlayConnectedPositions"
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isMenuOverlayTriggered">
  <div role="listbox" *ngIf="options.length > 0" [ngClass]="['menu', isMenuVisible ? 'visible' : '']" #dropdownMenu [attr.aria-labelledby]="dropdownLabel" [id]="id+'-panel'">
    <div class="menu__content">
      <valg-input-dropdown-option #allOptions
        *ngFor="let option of (externalAutoComplete ? options: (options | filter:'label':_primaryValue))" (click)="onItemClicked($event, option)"
        [id]="getDropdownItemComponentId(option)"
        [ngClass]="['menu__content__item', displayValue === option.label ? 'menu__content__item__selected': '', option.isEmptyOption ? 'menu__content__item__empty' : '']"
        [selected]="selectedItemComponentId === getDropdownItemComponentId(option)"
        (selectionChange)="onSelectionChange(option)"
      >
        {{option.label}}
      </valg-input-dropdown-option>
    </div>
  </div>
</ng-template>
